import { memo } from 'react';
import { UmbracoTypes } from '~/lib/data-contract';
import { useComplementaryResults } from '~/services/loop54/hooks';
import { CarouselWithItems } from './helpers';

function M30ComplementaryProductCarousel({
    headline,
    productId,
    setHasComplementaryProducts,
    inputRef,
}: Omit<UmbracoTypes.IM30ComplimentaryProductCarouselModule, 'type'>) {
    const { data } = useComplementaryResults(productId);

    return (
        <CarouselWithItems
            data={data?.results?.items}
            headline={headline}
            inputRef={inputRef}
            setHasProducts={setHasComplementaryProducts}
        />
    );
}

export default memo(M30ComplementaryProductCarousel);
